module.exports = __webpack_public_path__ + "img/verified-adyen.d9856679.png";